module.exports = __webpack_public_path__ + "img/ladyrednew.f34c74d1.png";